import { useCallback, useEffect, useState } from "react";

import { currentBerthStorage } from "@/utils/storageLocal";

/**
 * SessionStorageに保存されているバース情報を取得・更新するカスタムフック
 *
 * 現在の工場と異なる工場で選択された荷下ろし場は未選択（空文字）として返す（`currentBerthStorage` 参照）。
 */
export const useCurrentBerth = () => {
  const [currentBerth, setCurrentBerth] = useState<string | null>(null);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    setCurrentBerth(currentBerthStorage.read());
    setIsInitialized(true);
  }, []);

  const write = useCallback((newValue: string) => {
    currentBerthStorage.write(newValue);
    setCurrentBerth(newValue);
  }, []);

  return { currentBerth, write, isInitialized };
};
